import React from 'react';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

import { sidebarFieldKeyToIconComponent } from '~/components/ClaimPage/constants';
import type { ClaimSidebarFieldConfiguration } from '~/components/ClaimPage/types';
import { MainCard, Text } from '~/components/core';
import type { DndDragHandleProps } from '~/components/core/DndOrderedList/DndOrderedList.types';

type SidebarFieldConfigCardProps = {
  field: ClaimSidebarFieldConfiguration;
  dragHandleProps: DndDragHandleProps;
};

const SidebarFieldConfigCard = ({ field, dragHandleProps }: SidebarFieldConfigCardProps) => {
  const { field_key, display_name } = field;
  const Icon = sidebarFieldKeyToIconComponent[field_key];

  return (
    <MainCard type="filled">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-8">
          <Icon />
          <Text weight="semi-bold">{display_name}</Text>
        </div>
        <button
          {...dragHandleProps}
          className="flex cursor-grab items-center border-none bg-transparent p-0 text-slate-500 outline-none"
        >
          <DragIndicatorIcon />
        </button>
      </div>
    </MainCard>
  );
};

export default SidebarFieldConfigCard;
